export default __webpack_public_path__ + "static/media/EGGNOG.c5d4e908.svg";